













































import { Component, Vue } from 'vue-property-decorator';
import AuthModule from '@/store/modules/auth.module';
import TaftImageAnimated from '@/components/base-layout/TaftImageAnimated.vue';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    TaftImageAnimated,
  },
})
export default class Logout extends Vue {
  private authModule = getModule(AuthModule, this.$store);
  tryAgain = false;

  mounted() {
    this.signOut();
  }

  async signOut() {
    try {
      this.authModule.logout();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      // pushing to landing page if try again fails again
      if (this.tryAgain) {
        this.$router.push('/');
      }
      this.tryAgain = true;
    }
  }
}
